//
// Generated class AccountingJournalLineTemplate
//

/// <reference path="AccountingJournalLineTemplate_ManagedObject.ts" />

class AccountingJournalLineTemplate extends AccountingJournalLineTemplate_ManagedObject
{

}
